// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2tFQu","item":"PaymentsMobile_item__2_gPR","label":"PaymentsMobile_label__1Pv9E","amount":"PaymentsMobile_amount__2n8iH"};